module.exports = __webpack_public_path__ + "img/kefu1.20c60c2.png";